import { comboboxSlotRecipe } from "./recipes/combobox"
import { menuSlotRecipe } from "./recipes/menu"
import { selectSlotRecipe } from "./recipes/select"
import { stepsSlotRecipe } from "./recipes/steps"

export const slotRecipes = {
  select: selectSlotRecipe,
  combobox: comboboxSlotRecipe,
  steps: stepsSlotRecipe,
  menu: menuSlotRecipe
}